<template>
  <el-dialog
    custom-class="ceibsdialog"
    width="650px"
    :visible.sync="visible"
    :center="true"
    :before-close="beforeClosed"
    :close-on-click-modal="false"
    @open="loadApplyVo">
    <div slot="title" class="dialogtitle">{{ $t('lang.applyList.operations.startOnlinePay') }}</div>
    <div class="upload-dialog-content" v-if="applyVo">
      <el-radio-group v-model="applyVo.payType">
        <el-radio label="ONLINE">{{ $t('lang.submit.onlinePay') }}</el-radio>
        <el-radio label="CASH" v-if="allowCashPay">{{ $t('lang.submit.cash') }}</el-radio>
        <el-radio label="BANK_TRANSFER">{{ $t('lang.submit.bankTransfer') }}</el-radio>
      </el-radio-group>
      <upload-bank-transfer-voucher v-if="applyVo.payType === 'BANK_TRANSFER'" :apply-vo="applyVo" @submit="beforeClosed"></upload-bank-transfer-voucher>
      <div v-if="applyVo.payType === 'ONLINE'" style="margin-top: 20px">
        <el-button type="ceibsprimary" @click="gotoOnlinePay">{{ $t('lang.applyList.operations.startOnlinePay') }}</el-button>
      </div>
      <div v-if="applyVo.payType === 'CASH'" style="margin-top: 20px">
        <el-button type="ceibsprimary" @click="confirmCashPay">{{ $t('lang.applyList.confirmCashPay') }}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { confirmUseCashPay, find, initOnlinePayApplyList } from '@/api/apply'
import UploadBankTransferVoucher from '@/views/apply/record/component/uploadBankTransferVoucher'

export default {
  name: 'payDialog',
  components: { UploadBankTransferVoucher },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    applyVo: {
      type: Object
    }
  },
  data () {
    return {
      allowCashPay: false,
      payPlatformDto: null
    }
  },
  methods: {
    beforeClosed () {
      this.$emit('update:visible', false)
      this.$emit('submit')
    },
    loadApplyVo () {
      if (this.applyVo) {
        find({
          id: this.applyVo.id
        }).then(res => {
          const apply = res.data
          if (apply.applyType === 'PAPER') {
            this.allowCashPay = apply.packVoList.filter(pack => pack.receiveType === 'ON_SITE' || pack.receiveType === 'ENTRUST_ON_SITE').length > 0
          } else {
            this.allowCashPay = false
          }
        })
      }
    },
    confirmCashPay () {
      this.$confirm(this.$t('lang.applyList.confirmUseCashPay'), this.$t('lang.common.warning'), {
        type: 'warning',
        confirmButtonClass: 'el-button--ceibsprimary',
        cancelButtonClass: 'el-button--ceibs'
      }).then(() => {
        confirmUseCashPay({
          id: this.applyVo.id,
          lockVersion: this.applyVo.lockVersion
        }).then(res => {
          this.beforeClosed()
        })
      })
    },
    gotoOnlinePay () {
      initOnlinePayApplyList({
        id: this.applyVo.id,
        lockVersion: this.applyVo.lockVersion
      }).then(res => {
        window.location.href = res.data.payRedirectUrl
      })
    }
  }
}
</script>

<style scoped>
.dialogtitle {
  color: #a2100e;
}
</style>
